export default "__VITE_ASSET__ECpdZMyo__"